<template>
  <v-row>
    <v-col cols="12" md="8">
      <v-card
        :class="{
          'py-6 px-6': $vuetify.breakpoint.mdAndUp,
          'pa-5': $vuetify.breakpoint.smAndDown
        }"
        no-body
      >
        <span class="black--text text-h6 font-weight-black">{{ title }}</span>
        <span
          v-if="isGraduateForm"
          class="px-1 grey--text text--darken-2 mt-n5 pt-n5 "
        >
          (สามารถลาก่อนหรือกลับมาหลังจากการไปรับปริญญาได้)
        </span>
        <span
          v-if="isCremationForm"
          class="px-1 grey--text text--darken-2 mt-n5 pt-n5 "
        >
          (สามารถลาก่อนหรือกลับมาหลังจากจัดพิธีทางศาสนาญาติสายตรงที่เสียชีวิตได้)
        </span>

        <v-divider></v-divider>
        <v-row>
          <v-col cols="12">
            <v-form v-model="formValidate" ref="form">
              <v-container :class="{ 'pa-0': $vuetify.breakpoint.xsOnly }">
                <v-row class="mb-n2">
                  <v-col>
                    <span class="px-1 grey--text text--darken-2">
                      วันที่เขียน
                    </span>
                    <span class="black--text">
                      {{ otherData.leaveAssignDateText }}
                    </span>
                    <span class="px-1">,</span>
                    <span class="px-1">
                      {{ otherData.leaveTypeName }}
                    </span>
                    <span class="info--text px-1">
                      {{ otherData.leaveTypeDesc }}
                    </span>
                  </v-col>
                </v-row>

                <v-row class="mb-n2">
                  <v-col cols="12">
                    <v-text-field
                      v-model="form.LeaveHead"
                      ref="LeaveHead"
                      label="เรียน"
                      hide-details="auto"
                      :rules="[rules.required]"
                      required
                      outlined
                      dense
                      maxlength="255"
                    />
                  </v-col>
                </v-row>

                <v-row v-if="isGraduateForm">
                  <v-col
                    cols="12"
                    lg="6"
                    :class="{ 'pb-1': $vuetify.breakpoint.mdAndDown }"
                  >
                    <v-menu
                      v-model="graduateMenu"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          v-on="on"
                          ref="GraduationDate"
                          :value="graduateDateText"
                          label="วันที่เข้ารับปริญญา"
                          hide-details="auto"
                          append-icon="mdi-calendar"
                          :rules="[rules.required]"
                          readonly
                          required
                          outlined
                          dense
                          @click:append="graduateMenu = true"
                        />
                      </template>
                      <v-date-picker
                        no-title
                        v-model="form.GraduationDate"
                        :locale="$lang === 'Tha' ? 'th' : 'en'"
                        @input="graduateMenu = false"
                      ></v-date-picker>
                    </v-menu>
                  </v-col>

                  <v-col cols="12" lg="6">
                    <v-select
                      v-model="form.GraduationEducationLevelID"
                      ref="GraduationEducationLevelID"
                      :items="graduationLevelOptions"
                      item-text="text"
                      item-value="value"
                      label="ระดับการรับปริญญาบัตร"
                      hide-details
                      :rules="[rules.required]"
                      required
                      outlined
                      dense
                    />
                  </v-col>
                </v-row>

                <v-row v-if="isGraduateForm" class="mb-n2">
                  <v-col cols="12">
                    <v-text-field
                      v-model="form.GraduationInstituteName"
                      ref="GraduationInstituteName"
                      label="สถาบัน"
                      hide-details="auto"
                      :rules="[rules.requiredTrim]"
                      required
                      outlined
                      dense
                      maxlength="255"
                    />
                  </v-col>
                </v-row>

                <v-row v-if="isCremationForm">
                  <v-col
                    cols="12"
                    lg="6"
                    :class="{ 'pb-1': $vuetify.breakpoint.mdAndDown }"
                  >
                    <v-text-field
                      v-model="form.FamilyRelationshipName"
                      ref="FamilyRelationshipName"
                      label="ชื่อ-สกุล ญาติสายตรง"
                      hide-details="auto"
                      :rules="[rules.requiredTrim]"
                      required
                      outlined
                      dense
                      maxlength="255"
                    />
                  </v-col>

                  <v-col
                    cols="12"
                    lg="6"
                    :class="{ 'pt-1': $vuetify.breakpoint.mdAndDown }"
                  >
                    <v-select
                      v-model="form.FamilyRelationshipTypeID"
                      ref="FamilyRelationshipTypeID"
                      :items="familyRelationshipOptions"
                      item-text="text"
                      item-value="value"
                      label="ความเกี่ยวข้อง"
                      hide-details="auto"
                      :rules="[rules.required]"
                      required
                      outlined
                      dense
                      @change="onChangeDaySelection()"
                    />
                  </v-col>
                </v-row>

                <v-row class="py-3">
                  <v-col cols="12" class="py-0">
                    <v-checkbox
                      v-model="otherData.leaveOneDay"
                      class="ma-0"
                      label="ลาวันเดียว"
                      hide-details="auto"
                      @change="onChangeDaySelection()"
                    />
                  </v-col>
                </v-row>

                <v-row>
                  <v-col
                    cols="12"
                    lg="6"
                    :class="{ 'pb-1': $vuetify.breakpoint.mdAndDown }"
                  >
                    <v-menu
                      v-model="beginMenu"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          v-on="on"
                          ref="LeaveBeginDate"
                          :value="beginDateText"
                          label="ลาตั้งแต่วันที่"
                          hide-details="auto"
                          append-icon="mdi-calendar"
                          readonly
                          outlined
                          dense
                          @click:append="beginMenu = true"
                        />
                      </template>
                      <v-date-picker
                        no-title
                        v-model="form.LeaveBeginDate"
                        :locale="$lang === 'Tha' ? 'th' : 'en'"
                        @input="beginMenu = false"
                        @change="onChangeLeaveBeginDate()"
                      ></v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col
                    cols="12"
                    lg="6"
                    :class="{ 'pt-1': $vuetify.breakpoint.mdAndDown }"
                  >
                    <v-radio-group
                      v-model="form.LeaveBeginDayStatusID"
                      class="ma-0"
                      row
                      hide-details="auto"
                      @change="onChangeDaySelection()"
                    >
                      <v-radio label="เต็มวัน" value="ALL" />
                      <v-radio label="ครึ่งเช้า" value="AM" />
                      <v-radio label="ครึ่งบ่าย" value="PM" />
                    </v-radio-group>
                  </v-col>
                </v-row>

                <v-row
                  v-if="
                    !(
                      form.LeaveBeginDayStatusID === 'AM' ||
                      otherData.leaveOneDay
                    )
                  "
                >
                  <v-col
                    cols="12"
                    lg="6"
                    :class="{ 'pb-1': $vuetify.breakpoint.mdAndDown }"
                  >
                    <v-menu
                      v-model="finishMenu"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          v-on="on"
                          :value="finishDateText"
                          :disabled="
                            form.LeaveBeginDayStatusID === 'AM' ||
                              otherData.leaveOneDay
                          "
                          label="ลาถึงวันที่"
                          hide-details="auto"
                          append-icon="mdi-calendar"
                          readonly
                          outlined
                          dense
                          @click:append="finishMenu = true"
                        />
                      </template>
                      <v-date-picker
                        v-model="form.LeaveFinishDate"
                        :locale="$lang === 'Tha' ? 'th' : 'en'"
                        :min="
                          $dateFormat(form.LeaveBeginDate, {
                            addUnit: 'd',
                            addValue: 1
                          })
                        "
                        :disabled="
                          form.LeaveBeginDayStatusID === 'AM' ||
                            otherData.leaveOneDay
                        "
                        no-title
                        @input="finishMenu = false"
                        @change="onChangeDaySelection()"
                      ></v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col
                    cols="12"
                    lg="6"
                    :class="{ 'pt-1': $vuetify.breakpoint.mdAndDown }"
                  >
                    <v-radio-group
                      v-model="form.LeaveFinishDayStatusID"
                      class="ma-0"
                      row
                      hide-details="auto"
                      :disabled="
                        form.LeaveBeginDayStatusID === 'AM' ||
                          otherData.leaveOneDay
                      "
                      @change="onChangeDaySelection()"
                    >
                      <v-radio label="เต็มวัน" value="ALL" />
                      <v-radio label="ครึ่งเช้า" value="AM" />
                    </v-radio-group>
                  </v-col>
                </v-row>

                <v-row class="py-3">
                  <v-col cols="12" lg="auto" class="py-0">
                    <v-checkbox
                      v-model="form.CheckSaturday"
                      class="ma-0"
                      label="นับวันเสาร์เป็นวันทำงาน"
                      hide-details="auto"
                      @change="onChangeDaySelection()"
                    />
                  </v-col>
                  <v-col cols="12" lg="auto" class="py-0">
                    <v-checkbox
                      v-model="form.CheckSunday"
                      class="ma-0"
                      label="นับวันอาทิตย์เป็นวันทำงาน"
                      hide-details="auto"
                      @change="onChangeDaySelection()"
                    />
                  </v-col>
                  <v-col cols="12" lg="auto" class="py-0">
                    <v-checkbox
                      v-model="form.CheckHoliday"
                      class="ma-0"
                      label="นับวันหยุดนักขัตฤกษ์เป็นวันทำงาน"
                      hide-details="auto"
                      @change="onChangeDaySelection()"
                    />
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="12" class="mt-n2">
                    <span
                      class="px-1 error--text"
                      v-text="otherData.warningMessage"
                    />
                  </v-col>
                </v-row>

                <v-row>
                  <v-col />
                </v-row>

                <v-divider class="mt-n8" />

                <v-row>
                  <v-col />
                </v-row>

                <v-row class="mb-2">
                  <v-col cols="12" class="mt-n5">
                    <v-text-field
                      v-model="form.Address"
                      label="สามารถติดต่อได้ที่"
                      hide-details="auto"
                      outlined
                      dense
                      maxlength="255"
                    />
                  </v-col>
                </v-row>

                <v-row class="mt-n5">
                  <v-col cols="12" class="pb-0 pt-5 mb-0 black--text">
                    <b>
                      {{
                        isCremationForm
                          ? 'หลักฐานใบมรณะบัตร'
                          : 'หลักฐานในการตอบรับหรือเข้าร่วมพิธีพระราชทานปริญญาบัตร'
                      }}</b
                    >
                  </v-col>
                  <v-col
                    v-if="isGraduateForm"
                    cols="12"
                    class="pb-0 mb-0 grey--text"
                  >
                    (เช่น หน้าจอการตอบรับเข้าร่วม, ภาพถ่ายปริญญา)
                  </v-col>
                  <v-col
                    v-if="otherData.docName && form.KeepFileFlag"
                    cols="12"
                    class="sub-title2 py-0 pl-5 ma-0"
                  >
                    <span>เอกสารที่เคย upload ไว้ : </span>
                    <v-btn
                      class="primary--text text--darken-2"
                      text
                      @click="
                        onDownloadDocument({
                          leaveOrderID: leaveOrderId,
                          docFileName: otherData.docName
                        })
                      "
                    >
                      {{ otherData.docName }}
                    </v-btn>
                    <v-btn color="error" outlined @click="onRemoveAttachedFile">
                      ลบเอกสารแนบ
                    </v-btn>
                  </v-col>
                  <v-col cols="12">
                    <v-file-input
                      v-model="otherData.docFileName"
                      ref="docFileName"
                      label="แนบหลักฐานเพิ่มเติม"
                      hide-details="auto"
                      accept=".jpg, .jpeg, .png, .pdf"
                      :rules="[rules.requiredAttachment]"
                      required
                      outlined
                      dense
                      show-size
                      @change="onSelectFile"
                    />
                  </v-col>
                  <v-col cols="12" class="mt-n3">
                    <span class="grey--text"
                      >ขนาดไฟล์ไม่เกิน 2 MB และรองรับไฟล์นามสกุล .jpg, .png,
                      หรือ .pdf เท่านั้น</span
                    >
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="12">
                    <v-row class="ml-1">
                      <div>
                        <span
                          v-if="!otherData.employeeApprove[$lang]"
                          class="title error--text"
                          ref="leaveApprover"
                        >
                          *
                        </span>
                        <b>{{ approverTitle + ' : ' }}</b>
                        <span
                          v-if="!otherData.employeeApprove[$lang]"
                          class="title error--text"
                        >
                          กรุณาเลือกผู้ส่งต่อ
                        </span>
                        <span
                          v-else
                          class="title success--text"
                          v-text="otherData.employeeApprove[$lang] || ''"
                        />
                      </div>
                      <div v-if="!otherData.employeeApprove[$lang]">
                        <v-btn
                          color="primary"
                          outlined
                          @click="openDialog()"
                          class="white--text ml-2"
                        >
                          <v-icon>mdi-plus</v-icon>
                          ค้นหารายชื่อ</v-btn
                        >
                        <div>
                          <span v-if="leaveApproverStatus" class="error--text">
                            * กรุณาค้นหารายชื่อเพื่อส่งต่อ
                          </span>
                        </div>
                      </div>
                      <div v-else class="ml-2">
                        <v-btn
                          color="orange"
                          outlined
                          @click="openDialog()"
                          class="white--text"
                        >
                          <v-icon>mdi-pencil</v-icon>
                          เปลี่ยน</v-btn
                        >
                      </div>
                    </v-row>
                  </v-col>
                </v-row>

                <v-row class="mt-4" align="center">
                  <v-col cols="12">
                    <v-btn
                      :color="
                        isEditMode ? 'warning darken-1' : 'primary darken-2'
                      "
                      depressed
                      large
                      @click="onSubmitForm()"
                      class="float-right"
                    >
                      {{ isEditMode ? 'บันทึกการแก้ไข' : 'บันทึกข้อมูล' }}
                    </v-btn>

                    <v-btn
                      large
                      outlined
                      color="grey"
                      :to="`/leave/pending/${$guid}`"
                      depressed
                      class="float-right mr-1"
                    >
                      ยกเลิก
                    </v-btn>
                  </v-col>
                </v-row>
              </v-container>
            </v-form>
          </v-col>
        </v-row>
      </v-card>
    </v-col>

    <v-col cols="12" md="4">
      <div class="fixposition align-self-start hidden-sm-and-down shadowBox">
        <v-card-title>
          <span class="black--text font-weight-black">
            สรุปการลา
          </span>
        </v-card-title>
        <v-card-text>
          <leave-cal-right-box-short
            :otherData="otherData"
            :form="form"
            :beginDateText="beginDateText"
            :finishDateText="finishDateText"
          />
        </v-card-text>
      </div>
    </v-col>

    <v-col cols="12" class="hidden-md-and-up">
      <v-expand-transition>
        <v-footer app padless v-show="!isFooterShowAll">
          <v-card class="flex rounded-lg rounded-b-0" elevation="10">
            <v-card-title class="mt-n4">
              <v-row>
                <v-col cols="6">
                  <span class="black--text text-h6 font-weight-black"
                    >สรุปการลา</span
                  >
                </v-col>
                <v-col cols="6" class="text-end">
                  <a @click="isFooterShowAll = true">
                    <span class="grey--text text-body-2">รายละเอียดทั้งหมด</span
                    ><v-icon small>mdi-chevron-up</v-icon>
                  </a>
                </v-col>
              </v-row>
            </v-card-title>
            <v-card-text class="mb-n2">
              <v-row class="mt-n5">
                <v-col cols="3">
                  <span class="text--primary">ต้องการลา</span>
                </v-col>
                <v-col cols="9" class="text-end">
                  <v-chip small color="#E7EDF5">
                    <span class="primary--text text--darken-2">
                      {{ beginDateText }}</span
                    >
                    <span
                      v-if="
                        !(
                          form.LeaveBeginDayStatusID === 'AM' ||
                          otherData.leaveOneDay
                        )
                      "
                      class="primary--text text--darken-2"
                    >
                      - {{ finishDateText }}
                    </span>
                  </v-chip>
                </v-col>
              </v-row>

              <v-row class="mt-n5">
                <v-col cols="6"> <span>จำนวนวันที่ต้องการลา</span> </v-col>
                <v-col cols="6" class="text-end">
                  <span
                    class="text-h3 mr-2 font-weight-black primary--text text--darken-2"
                    >{{ form.LeaveAmountDay }}</span
                  >
                  <span class="grey--text">วันทำการ</span>
                </v-col>
              </v-row>
              <v-row class="mt-n6 mb-n4" v-if="otherData.overLimitDay > 0">
                <v-col cols="6">
                  <span class="error--text">จำนวนวันลาเกินสิทธิ์</span>
                </v-col>
                <v-col cols="6" class="text-end">
                  <span class="text-h6 mr-2 font-weight-black error--text">{{
                    otherData.overLimitDay
                  }}</span
                  ><span class="error--text">วัน</span>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-footer>
      </v-expand-transition>
    </v-col>

    <v-col cols="12" class="hidden-md-and-up">
      <v-expand-transition>
        <v-footer app padless v-show="isFooterShowAll">
          <v-card class="flex rounded-lg rounded-b-0" elevation="10">
            <v-card-title class="mt-n4">
              <v-row>
                <v-col cols="6">
                  <span class="black--text text-h6 font-weight-black"
                    >สรุปการลา</span
                  >
                </v-col>
                <v-col cols="6" class="text-end">
                  <a @click="isFooterShowAll = false">
                    <span class="grey--text text-body-2"
                      >รายละเอียดทั้งหมด</span
                    >
                    <v-icon small>mdi-chevron-down</v-icon>
                  </a>
                </v-col>
              </v-row>
            </v-card-title>
            <v-card-text>
              <leave-cal-right-box-short
                :otherData="otherData"
                :form="form"
                :beginDateText="beginDateText"
                :finishDateText="finishDateText"
              />
            </v-card-text>
          </v-card>
        </v-footer>
      </v-expand-transition>
    </v-col>

    <v-col cols="12">
      <v-dialog v-model="conDialogOnSubmitForm" max-width="500px">
        <v-card class="py-2">
          <v-card-title class="headline Black--text"
            >ยืนยันการบันทึกการลา</v-card-title
          >

          <v-card-text class="mb-4">
            <v-divider class="mb-2"></v-divider>
            <span class="text-body-1">ส่งรายการลาไปยัง </span>
            <span class="font-weight-bold">
              {{ otherData.employeeApprove[$lang] }}</span
            >
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <div class="mr-4 mt-n8">
              <v-btn
                class="white--text mr-2"
                color="error"
                outlined
                @click="conDialogOnSubmitForm = false"
                >ยกเลิก
              </v-btn>
              <v-btn
                class="white--text mr-2"
                color="success"
                @click="conOnSubmitForm"
                >ยืนยัน
              </v-btn>
            </div>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-col>

    <v-col cols="12">
      <v-dialog v-model="loading1" hide-overlay persistent max-width="300">
        <v-card color="primary" dark>
          <v-card-text>
            กำลังบันทึก...
            <v-progress-linear
              indeterminate
              color="white"
              class="mb-0"
            ></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-col>

    <v-col cols="12">
      <v-dialog v-model="searchDialog" max-width="800">
        <v-card>
          <v-card-title class="headline Black--text">
            ค้นหารายชื่อ
          </v-card-title>
          <v-card-text class="mb-2">
            <v-divider class="mb-2"></v-divider>
            <leave-search-employee
              :selected-employee="form.EmployeeApproveID"
              :list="employeeApproveList"
              :isload="loading"
              @search="onSearchEmpApprove"
              @select="onSelectApprover"
            />
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <div class="mr-4 mt-n5 mb-3">
              <v-btn
                class="white--text mr-2"
                color="grey"
                outlined
                @click="searchDialog = false"
                >ยกเลิก
              </v-btn>
              <v-btn
                class="white--text"
                color="primary"
                @click="btnSubmitSelect"
                :disabled="checkSearch"
                >บันทึก
              </v-btn>
            </div>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-col>

    <v-col cols="12">
      <app-message-dialog
        :value="usedLeaveLimitDialog"
        :message="usedLeaveLimitMessage"
        @confirm="onCloseUsedLeaveLimitDialog"
      />
    </v-col>
  </v-row>
</template>

<script>
import LeaveSearchEmployee from '@/components/leave/LeaveForm/LeaveSearchEmployeeDialogAuto'
import LeaveCalRightBoxShort from '@/components/leave/LeaveCalRightBoxShort'

export default {
  components: {
    LeaveSearchEmployee,
    LeaveCalRightBoxShort
  },

  props: {
    title: {
      type: String,
      default: ''
    },

    type: {
      type: String,
      default: '27'
    }
  },

  data() {
    return {
      conDialogOnSubmitForm: false,
      loading1: false,
      loading: false,
      usedLeaveLimitDialog: false,
      usedLeaveLimitMessage: '',
      formValidate: null,
      graduateMenu: false,
      beginMenu: false,
      finishMenu: false,
      searchDialog: false,
      form: {},
      otherData: {
        leaveOneDay: null,
        docName: null,
        docFileName: null,
        leaveDayName: null,
        budgetYear: null,
        employeeApproveKeyword: '',
        employeeApprove: {
          ID: null,
          Tha: null,
          Eng: null
        },
        employeeName: {
          Tha: null,
          Eng: null
        },
        positionName: {
          Tha: null,
          Eng: null
        },
        orgNameAll: {
          Tha: null,
          Eng: null
        },
        leaveAssignDateText: null,
        leaveTypeName: null,
        leaveTypeDesc: null,
        warningMessage: '',
        overLimitDay: 0
      },
      leaveInfo: {},
      employeeApproveList: [],
      dataSelect: {},
      leaveApproverStatus: false,
      isFooterShowAll: false,
      graduationLevelOptions: [
        { text: 'ปริญญาตรี', value: '6' },
        { text: 'ปริญญาโท', value: '7' },
        { text: 'ปริญญาเอก', value: '8' }
      ]
    }
  },

  computed: {
    getdateNowThaFormat() {
      const date = new Date()
      return this.$dateFormatByLang(date, {
        format: 'DD MMMM YYYY',
        addUnit: 'Y',
        addValue: '543'
      })
    },

    yearRelexcheck() {
      return !this.form.LimitDay ? '0' : '10'
    },

    leaveCalLimitDayQuota() {
      return (this.form.LimitDay || 0) - (this.form.StatLeaveLastDay || 0)
    },

    leaveBalanceQuota() {
      return this.leaveCalLimitDayQuota - (this.form.LeaveAmountDay || 0)
    },

    leaveOrderId() {
      return this.$route.params.leaveOrderId || '0'
    },

    graduateDateText() {
      return this.$dateFormatByLang(this.form.GraduationDate, {
        format: 'DD MMMM YYYY',
        addUnit: 'Y',
        addValue: '543'
      })
    },

    beginDateText() {
      return this.$dateFormatByLang(this.form.LeaveBeginDate, {
        format: 'DD MMMM YYYY',
        addUnit: 'Y',
        addValue: '543'
      })
    },

    finishDateText() {
      return this.$dateFormatByLang(this.form.LeaveFinishDate, {
        format: 'DD MMMM YYYY',
        addUnit: 'Y',
        addValue: '543'
      })
    },

    checkSearch() {
      return !this.dataSelect.employeeID
    },

    familyRelationshipOptions() {
      return [
        { text: 'คู่สมรส', value: 1 },
        { text: 'บิดา', value: 2 },
        { text: 'มารดา', value: 3 },
        { text: 'บุตร', value: 4 }
      ]
    },

    rules() {
      return {
        required: v => !!v || 'กรุณากรอกข้อมูลช่องนี้',
        requiredTrim: v =>
          !!(v && v.toString().trim()) || 'กรุณากรอกข้อมูลช่องนี้',
        requiredAttachment: () => this.hasAttachedDocument || 'กรุณาแนบเอกสาร'
      }
    },

    isEditMode() {
      return !!this.$route.params.leaveOrderId
    },

    isGraduateForm() {
      return this.type === '27'
    },

    isCremationForm() {
      return this.type === '28'
    },

    fixedLeaveReason() {
      return this.isCremationForm
        ? 'จัดพิธีทางศาสนาญาติสายตรงที่เสียชีวิต'
        : 'เข้าร่วมรับปริญญาบัตร'
    },

    maxLeaveAmountDay() {
      return this.isCremationForm ? 3 : 5
    },

    isLeaveAmountOverLimit() {
      return Number(this.form.LeaveAmountDay) > this.form.LimitDay
    },

    hasAttachedDocument() {
      return !!(
        this.otherData.docFileName ||
        (this.otherData.docName && this.form.KeepFileFlag)
      )
    },

    approverTitle() {
      return 'ผู้บังคับบัญชา/ผู้ตรวจสอบการลา/ผู้อนุมัติการลา'
    }
  },

  watch: {
    'form.LeaveBeginDate'() {
      if (this.form.LeaveBeginDate >= this.form.LeaveFinishDate) {
        this.form.LeaveFinishDate = this.$dateFormat(this.form.LeaveBeginDate, {
          addValue: 1,
          addUnit: 'd'
        })
      }
    },

    otherData: {
      deep: true,
      handler() {
        this.$emit('updateOtherData', this.otherData)
      }
    },

    loading: {
      deep: true,
      handler() {
        this.$emit('updateLoading', this.loading)
      }
    }
  },

  async mounted() {
    this.leaveInfo = await this.apiGetLeaveInfo()
    this.intitialForm()
  },

  methods: {
    onChangeLeaveBeginDate() {
      this.form.LeaveFinishDate = this.$dateFormat(this.form.LeaveBeginDate, {
        addUnit: 'd',
        addValue: 1
      })
      this.onChangeDaySelection()
    },

    intitialForm() {
      this.form = {
        LeaveOrderID: this.leaveOrderId,
        EmployeeID: this.$guid,
        LeaveTypeID: this.type,
        LeaveHead: this.leaveInfo.leaveHead || '',
        LeaveReason: this.fixedLeaveReason,
        GraduationDate: this.isGraduateForm
          ? this.$dateFormat(
              this.leaveInfo.graduationDate ||
                this.leaveInfo.graduateDate ||
                this.leaveInfo.receiveGraduateDate
            ) || new Date().toISOString().substr(0, 10)
          : '',
        GraduationEducationLevelID: this.isGraduateForm
          ? this.getDefaultEducationLevel()
          : '',
        GraduationInstituteName: this.isGraduateForm
          ? this.leaveInfo.graduationInstituteName ||
            this.leaveInfo.instituteName ||
            ''
          : '',
        FamilyRelationshipName: this.isCremationForm
          ? this.leaveInfo.familyRelationshipName ||
            this.leaveInfo.familyName ||
            ''
          : '',
        FamilyRelationshipTypeID: this.isCremationForm
          ? this.getDefaultFamilyRelationshipType()
          : 0,
        LeaveBeginDate:
          this.$dateFormat(this.leaveInfo.leaveBeginDate) ||
          new Date().toISOString().substr(0, 10),
        LeaveBeginDayStatusID: this.leaveInfo.leaveBeginDayStatusID || 'ALL',
        LeaveFinishDate:
          this.$dateFormat(this.leaveInfo.leaveFinishDate) ||
          this.$dateFormat(new Date().toISOString().substr(0, 10), {
            addUnit: 'd',
            addValue: 1
          }),
        LeaveFinishDayStatusID: this.leaveInfo.leaveFinishDayStatusID || 'ALL',
        LeaveAmountDay: this.leaveInfo.leaveAmountDay || 0,
        LeaveAmountDayAll: this.leaveInfo.leaveAmountDay || 1,
        CheckSaturday: this.leaveInfo.checkSaturday || false,
        CheckSunday: this.leaveInfo.checkSunday || false,
        CheckHoliday: this.leaveInfo.checkHoliday || false,
        LeaveLastBeginDate:
          this.$dateFormat(this.leaveInfo.leaveLastBeginDate) || '',
        LeaveLastFinishDate:
          this.$dateFormat(this.leaveInfo.leaveLastFinishDate) || '',
        LeaveLastAmountDay: this.leaveInfo.leaveLastAmountDay || 0,
        Address: this.leaveInfo.address || '',
        StatLeaveLastDay: this.leaveInfo.statLeaveLastDay || 0,
        StatLeaveNowDay: this.leaveInfo.statLeaveLastDay || 0,
        LimitDay: this.leaveInfo.limitDay || 0,
        Userwork: '',
        SignName: '',
        SignPositionName: '',
        EmployeeApproveID: this.leaveInfo.employeeApproveID || '',
        EmployeeApproveTypeID: 'Approve',
        OverLimitDay: this.leaveInfo.overLimitDay || 0,
        KeepFileFlag: this.leaveInfo.keepFileFlag || true,
        RelaxLastYearDay: this.leaveInfo.relaxLastYearDay || 0,
        LeaveReasonID: this.leaveInfo.leaveReasonID || 0
      }

      this.otherData = {
        leaveOneDay:
          this.leaveInfo.leaveBeginDate === this.leaveInfo.leaveFinishDate &&
          this.leaveInfo.leaveBeginDayStatusID ===
            this.leaveInfo.leaveFinishDayStatusID,
        leaveLastBeginDate:
          this.$dateFormatByLang(this.leaveInfo.leaveLastBeginDate) || '',
        leaveLastFinishDate:
          this.$dateFormatByLang(this.leaveInfo.leaveLastFinishDate) || '',
        docName: this.leaveInfo.docFileName || null,
        docFileName: null,
        leaveDayName: this.leaveInfo.leaveDayName || 'วันทำการ',
        budgetYear:
          this.leaveInfo.budgetYear || new Date().toISOString().substr(0, 4),
        employeeApproveKeyword: '',
        employeeApprove: {
          ID: this.leaveInfo.employeeApproveNameID,
          Tha: this.leaveInfo.employeeApproveNameTha,
          Eng: this.leaveInfo.employeeApproveNameEng
        },
        employeeName: {
          Tha: this.leaveInfo.employeeNameTha,
          Eng: this.leaveInfo.employeeNameEng
        },
        positionName: {
          Tha: this.leaveInfo.positionNameTha,
          Eng: this.leaveInfo.positionNameEng
        },
        orgNameAll: {
          Tha: this.leaveInfo.orgNameAllTha,
          Eng: this.leaveInfo.orgNameAllEng
        },
        leaveAssignDateText: this.$dateFormatByLang(
          this.leaveInfo.leaveAssignDate
        ),
        leaveTypeName: this.leaveInfo.leaveTypeName,
        leaveTypeDesc: this.leaveInfo.leaveTypeDesc,
        statLeaveTotal:
          parseFloat(this.form.StatLeaveLastDay) +
          parseFloat(this.form.StatLeaveNowDay),
        warningMessage: '',
        overLimitDay: this.leaveInfo.overLimitDay || 0
      }

      this.onChangeDaySelection()
    },

    getDefaultEducationLevel() {
      const value =
        this.leaveInfo.graduationEducationLevelID ||
        this.leaveInfo.educationLevelID ||
        this.leaveInfo.graduationLevelID ||
        this.leaveInfo.degreeLevelID
      return value ? value.toString() : ''
    },

    getDefaultFamilyRelationshipType() {
      const value =
        this.leaveInfo.familyRelationshipTypeID ||
        this.leaveInfo.relationshipTypeID ||
        this.leaveInfo.familyRelationTypeID
      return value ? Number(value) : 0
    },

    getLeaveLimitMessage() {
      if (this.isCremationForm) {
        return 'ลากิจพิเศษจัดพิธีทางศาสนาญาติสายตรงที่เสียชีวิต ลาได้ไม่เกิน 3 วันทำการ'
      }

      return `${this.otherData.leaveTypeName ||
        'รายการลา'} 1 ครั้งลาได้ไม่เกิน ${this.maxLeaveAmountDay} วันทำการ`
    },

    getWarningMessage(baseWarningMessage = '') {
      if (this.isLeaveAmountOverLimit) {
        return [baseWarningMessage, this.getLeaveLimitMessage()]
          .filter(Boolean)
          .join(' ')
      }

      return baseWarningMessage
    },

    openDialog() {
      this.searchDialog = true
      this.employeeApproveList = []
      this.dataSelect = {
        employeeID: '',
        employeeNameTha: '',
        employeeNameEng: '',
        EmployeeApproveID: ''
      }
    },

    onSelectFile(file) {
      if (file) {
        const filename = file.name.split('.')
        const fileExt = filename[filename.length - 1].toLowerCase()
        const accepted = ['jpg', 'jpeg', 'png', 'pdf']

        if (accepted.includes(fileExt)) {
          this.otherData.docFileName = file
        } else {
          alert(this.$t('alertErrorMessage.noAcceptFileType'))
          this.otherData.docFileName = null
        }
      } else {
        this.otherData.docFileName = null
      }
    },

    async onSearchEmpApprove(keyword) {
      this.otherData.employeeApproveKeyword = keyword
      if (this.otherData.employeeApproveKeyword.length > 1) {
        this.employeeApproveList = await this.apiPostSearchEmployeeByKeyword()
      }
    },

    onSelectApprover(item) {
      this.dataSelect = {
        employeeID: item.employeeID,
        employeeNameTha: item.employeeNameTha,
        employeeNameEng: item.employeeNameEng,
        EmployeeApproveID: item.employeeID
      }
      this.form.EmployeeApproveID = item.employeeID
      this.leaveApproverStatus = false
    },

    btnSubmitSelect() {
      this.otherData.employeeApprove.ID = this.dataSelect.employeeID
      this.otherData.employeeApprove.Tha = this.dataSelect.employeeNameTha
      this.otherData.employeeApprove.Eng = this.dataSelect.employeeNameEng
      this.form.EmployeeApproveID = this.dataSelect.EmployeeApproveID
      this.searchDialog = false
    },

    async onChangeDaySelection() {
      const res = await this.apiPostComputeDay()
      const firstItem = res.length > 0 ? res[0] : null

      if (!firstItem) return

      this.form.LeaveAmountDay = firstItem.leaveAmountDay || 0
      this.form.LeaveAmountDayAll = firstItem.leaveAmountDayAll || 0
      this.form.LeaveLastAmountDay = firstItem.leaveLastAmountDay || 0
      this.form.LeaveLastBeginDate =
        this.$dateFormat(firstItem.leaveLastBeginDate) || ''
      this.form.LeaveLastFinishDate =
        this.$dateFormat(firstItem.leaveLastFinishDate) || ''
      this.form.StatLeaveLastDay = firstItem.statLeaveLastDay || 0
      this.form.StatLeaveNowDay = firstItem.statLeaveNowDay || 0
      this.form.OverLimitDay = firstItem.overLimitDay || 0
      this.form.LimitDay = firstItem.limitDay || 0

      this.otherData.leaveLastBeginDate =
        this.$dateFormatByLang(firstItem.leaveLastBeginDate) || ''
      this.otherData.leaveLastFinishDate =
        this.$dateFormatByLang(firstItem.leaveLastFinishDate) || ''
      this.otherData.budgetYear = firstItem.budgetYear
      this.otherData.leaveTypeName = firstItem.leaveTypeName
      this.otherData.leaveTypeDesc = firstItem.comment
      this.otherData.leaveDayName = firstItem.leaveDayName
      this.otherData.statLeaveTotal =
        parseFloat(this.form.StatLeaveLastDay) +
        parseFloat(this.form.StatLeaveNowDay)
      this.otherData.warningMessage = this.getWarningMessage(
        firstItem.warningMessage
      )
      this.otherData.overLimitDay = firstItem.overLimitDay

      if (this.isLeaveAmountOverLimit) {
        this.usedLeaveLimitMessage = this.getLeaveLimitMessage()
        // this.usedLeaveLimitDialog = true
      }
    },

    onCloseUsedLeaveLimitDialog() {
      this.usedLeaveLimitDialog = false
      this.usedLeaveLimitMessage = ''
      const selectedBeginDate =
        this.form.LeaveBeginDate || new Date().toISOString().substr(0, 10)
      this.form.LeaveBeginDate = selectedBeginDate
      this.form.LeaveFinishDate = this.$dateFormat(selectedBeginDate, {
        addUnit: 'd',
        addValue: 1
      })
      this.form.LeaveBeginDayStatusID = 'ALL'
      this.form.LeaveFinishDayStatusID = 'ALL'
      this.otherData.leaveOneDay = false
      this.onChangeDaySelection()
    },

    async onDownloadDocument(item) {
      try {
        const payload = {
          leaveOrderID: item.leaveOrderID,
          docFileName: item.docFileName
        }
        const res = await this.$store.dispatch(
          'leave/getAttachedDocumentDownload',
          payload
        )

        var fileURL = window.URL.createObjectURL(
          new Blob([res.data], { type: 'application/pdf' })
        )
        var link = document.createElement('a')
        link.href = fileURL
        link.download = item.docFileName
        link.click()
      } catch (e) {
        console.log(e.response || e)
      }
    },

    onRemoveAttachedFile() {
      if (confirm('ยืนยันการลบไฟล์แนบ')) {
        this.form.KeepFileFlag = false
        this.$nextTick(() => {
          if (this.$refs.docFileName) {
            this.$refs.docFileName.validate()
          }
        })
      }
    },

    async onSubmitForm() {
      if (this.isLeaveAmountOverLimit) {
        this.usedLeaveLimitMessage = this.getLeaveLimitMessage()
        // this.usedLeaveLimitDialog = true
        // return
      }

      if (this.$refs.form.validate() && this.form.EmployeeApproveID) {
        this.conDialogOnSubmitForm = true
      } else {
        let element = ''
        if (!this.form.LeaveHead) {
          element = 'LeaveHead'
        } else if (this.isGraduateForm && !this.form.GraduationDate) {
          element = 'GraduationDate'
        } else if (
          this.isGraduateForm &&
          !this.form.GraduationEducationLevelID
        ) {
          element = 'GraduationEducationLevelID'
        } else if (
          this.isGraduateForm &&
          !(
            this.form.GraduationInstituteName &&
            this.form.GraduationInstituteName.toString().trim()
          )
        ) {
          element = 'GraduationInstituteName'
        } else if (
          this.isCremationForm &&
          !(
            this.form.FamilyRelationshipName &&
            this.form.FamilyRelationshipName.toString().trim()
          )
        ) {
          element = 'FamilyRelationshipName'
        } else if (
          this.isCremationForm &&
          !this.form.FamilyRelationshipTypeID
        ) {
          element = 'FamilyRelationshipTypeID'
        } else if (!this.hasAttachedDocument) {
          element = 'docFileName'
        } else {
          element = 'leaveApprover'
        }

        this.leaveApproverStatus = !this.form.EmployeeApproveID
        if (this.$refs[element]) {
          this.$vuetify.goTo(this.$refs[element], { offset: 20 })
        }
      }
    },

    async conOnSubmitForm() {
      this.conDialogOnSubmitForm = false
      this.loading1 = true
      try {
        const res = await this.apiPostCreateCommonLeave()
        if (res) {
          this.$router.push('/leave/pending/' + this.$guid)
          this.loading1 = false
        }
      } catch (e) {
        console.log(e.response || e)
      } finally {
        this.loading1 = false
      }
    },

    async apiGetLeaveInfo() {
      this.loading = true
      const body = {
        employeeId: this.$guid,
        leaveOrderId: this.$route.params.leaveOrderId || 0,
        leaveType: this.type
      }

      try {
        const res = await this.$store.dispatch(
          'leave/getInfoByLeaveOrderID',
          body
        )
        return res.data?.data[0] || {}
      } catch (e) {
        console.log(e.response || e)
      } finally {
        this.loading = false
      }
    },

    async apiPostSearchEmployeeByKeyword() {
      this.loading = true
      const body = {
        Keyword: this.otherData.employeeApproveKeyword
      }
      try {
        const res = await this.$store.dispatch(
          'leave/postSearchEmployeeByKeyword',
          body
        )
        return res.data?.data || []
      } catch (e) {
        console.log(e.response || e)
      } finally {
        this.loading = false
      }
    },

    async apiPostComputeDay() {
      this.loading = true
      const finishDate =
        this.otherData.leaveOneDay || this.form.LeaveBeginDayStatusID === 'AM'
          ? this.form.LeaveBeginDate
          : this.form.LeaveBeginDate >= this.form.LeaveFinishDate
          ? this.$dateFormat(this.form.LeaveBeginDate, {
              addUnit: 'd',
              addValue: 1
            })
          : this.form.LeaveFinishDate

      const body = {
        EmployeeID: this.$guid,
        LeaveTypeID: this.type,
        LeaveBeginDate: this.form.LeaveBeginDate,
        LeaveBeginDayStatusID: this.form.LeaveBeginDayStatusID,
        LeaveFinishDate: finishDate,
        LeaveFinishDayStatusID: this.form.LeaveFinishDayStatusID,
        CheckSaturday: this.form.CheckSaturday,
        CheckSunday: this.form.CheckSunday,
        CheckHoliday: this.form.CheckHoliday,
        GraduationDate: this.isGraduateForm ? this.form.GraduationDate : '',
        FamilyRelationshipName: this.isCremationForm
          ? this.form.FamilyRelationshipName
          : '',
        FamilyRelationshipTypeID: this.isCremationForm
          ? this.form.FamilyRelationshipTypeID || 0
          : 0
      }

      try {
        const res = await this.$store.dispatch(
          'leave/postComputeDaySpecial',
          body
        )
        const data = res.data?.data || []
        const usedLeaveLimit = data.find(
          item =>
            item.usedLeaveLimitMessage !== null &&
            item.usedLeaveLimitMessage !== ''
        )

        if (usedLeaveLimit) {
          this.usedLeaveLimitMessage = usedLeaveLimit.usedLeaveLimitMessage
          this.usedLeaveLimitDialog = true
          return []
        }

        return data
      } catch (e) {
        console.log(e.response || e)
        return []
      } finally {
        this.loading = false
      }
    },

    async apiPostCreateCommonLeave() {
      this.loading = true
      try {
        let formData = new FormData()
        let formStringConverted = {}

        for (const [key, value] of Object.entries(this.form)) {
          if (typeof value === 'boolean') {
            formStringConverted[key] = value ? 'true' : 'false'
          } else if (typeof value === 'number') {
            formStringConverted[key] = value.toString()
          } else {
            formStringConverted[key] = value ? value.toString() : ''
          }
        }

        if (
          this.otherData.leaveOneDay ||
          formStringConverted.LeaveBeginDayStatusID === 'AM'
        ) {
          formStringConverted.LeaveFinishDate =
            formStringConverted.LeaveBeginDate
          formStringConverted.LeaveFinishDayStatusID =
            formStringConverted.LeaveBeginDayStatusID
        }

        formStringConverted.LeaveReason = this.fixedLeaveReason
        formStringConverted.FamilyRelationshipName = this.isCremationForm
          ? this.form.FamilyRelationshipName || ''
          : ''
        formStringConverted.FamilyRelationshipTypeID = this.isCremationForm
          ? Number(this.form.FamilyRelationshipTypeID || 0)
          : 0
        formStringConverted.SignName = ''
        formStringConverted.SignPositionName = ''

        if (this.otherData.docFileName) {
          formStringConverted.KeepFileFlag = 'false'
          formData.append('filename1', this.otherData.docFileName)
        }

        formData.append('dataEform', JSON.stringify(formStringConverted))

        const res = await this.$store.dispatch(
          'leave/postCreateCommonLeave',
          formData
        )
        return res.data?.data || []
      } catch (e) {
        console.log(e.response || e)
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.v-file-input {
  flex-direction: row-reverse;
}

.fixposition {
  position: sticky;
  top: 7%;
}

.shadowBox {
  background: #fff;
  border-radius: 5px;
  box-shadow: 0 5px 20px rgba(7, 77, 168, 0.19),
    0 2px 2px rgba(13, 112, 193, 0.23);
  border-style: solid;
  border-width: 1px;
  border-color: rgba(13, 112, 193, 0.1);
}
</style>
